export default {
  firstName: 'John',
  lastName: 'Smith',
  avatar: 'https://s3-eu-west-1.amazonaws.com/nvtk-user-avatar/defaults/4.svg',
  token: 'token',
  roles: [],
}
